import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ChangeUserPassword from "./../../pages/ChangeUserPassword/ChangeUserPassword";
import SignOut from "./../auth/SignOut";
import TalaeraDefaultBackground from "./../TalaeraDefaultBackground/TalaeraDefaultBackground";
import PrivateRoute from "./PrivateRoute";
import TalaeraRoutes from "./TalaeraRoutes";
import { ErrorBoundary } from "components/ErrorBoundary";
import UnauthRoutes from "./UnauthRoutes";
import PreserveQueryRedirect from "components/RedirectWithQueryParams/RedirectWithQueryParams";

const AsyncAdminDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminDashboardPage" */
      "./../../pages/admin/AdminDashboard/AdminDashboardPage"
    )
);

const AsyncAdminUser = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminUserPage" */
      "./../../pages/admin/AdminUser/AdminUserPage"
    )
);

const AsyncAdminCompany = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminCompanyPage" */
      "./../../pages/admin/AdminCompany/AdminCompanyPage"
    )
);

const AsyncAdminCompanyDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CompanyDashboardPage" */
      "../../pages/team/CompanyDashboard/TeamsPage"
    )
);

const AsyncAdminCompanyReports = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CompanyDashboardPage" */
      "../../pages/team/ReportsPage/index"
    )
);

const AsyncAdminCompanyTeam = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminCompanyTeamPage" */
      "./../../pages/admin/AdminCompanyTeam/AdminCompanyTeamPage"
    )
);

const AsyncAdminSession = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSessionPage" */
      "./../../pages/admin/AdminSession/AdminSessionPage"
    )
);

const AsyncAdminMonitoring = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminMonitoringShiftPage" */
      "./../../pages/admin/AdminMonitoring/AdminMonitoringShiftPage"
    )
);

const AsyncAdminQuestion = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminQuestionPage" */
      "./../../pages/admin/AdminQuestion/AdminQuestionPage"
    )
);

const AsyncAdminSchool = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSchoolPage" */
      "./../../pages/admin/AdminSchool/AdminSchoolPage"
    )
);

const AsyncAdminSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminSettingsPage" */
      "../../pages/admin/AdminSettings/AdminSettingsPage"
    )
);

const AsyncAdminBuildExercise = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminBuildExercisePage" */
      "./../../pages/admin/AdminBuildExercise/AdminBuildExercisePage"
    )
);

const AsyncAdminExercise = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminExercisePage" */
      "./../../pages/admin/AdminExercise/AdminExercisePage"
    )
);

const AsyncAdminTag = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminTagPage" */
      "./../../pages/admin/AdminTag/AdminTagPage"
    )
);

const AsyncAdminWorkshop = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminTagPage" */
      "./../../pages/admin/AdminWorkshop/AdminWorkshop"
    )
);

const AsyncContentFolder = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContentFolderPage" */
      "./../../pages/content/ContentFolderPage"
    )
);

const AsyncEditContentFile = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EditContentFilePage" */
      "./../../pages/content/EditContentFilePage"
    )
);

const AsyncLibrary = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LibraryPage" */
      "./../../pages/Library/LibraryPage"
    )
);

const AsyncLibraryRoot = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LibraryRootPage" */
      "../../pages/Library/LibraryRootPage"
    )
);

const AsyncCoursePage = React.lazy(() => import("./../../pages/Course/CoursePage"));

const AsyncAdminPricingModel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminPricingModelPage" */
      "./../../pages/admin/AdminPricingModel/AdminPricingModelPage"
    )
);

export default class AdminRoutes extends Component {
  render() {
    return (
      <ErrorBoundary pathname={this.props.location?.pathname}>
        <Routes key={this.props.location.pathname}>
          <Route
            path={TalaeraRoutes.ROOT.path}
            element={
              <Navigate to={TalaeraRoutes.ADMIN_ROOT.path.replace("*", "")} replace />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_COMPANY_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminCompany}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_COMPANY_DASHBOARD.path}
            element={
              <PrivateRoute component={AsyncAdminCompanyDashboard} permissions="admin" />
            }
          />

          <Route
            path={TalaeraRoutes.COMPANY_REPORTS_PAGE.path}
            element={
              <PrivateRoute
                component={AsyncAdminCompanyReports}
                permissions={"admin"}
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_COMPANY_USER_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminUser}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_COMPANY_TEAM_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminCompanyTeam}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_TEAM_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminCompanyTeam}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_USER_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminUser}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_SESSION_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminSession}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_MONITORING_SHIFT.path}
            element={
              <PrivateRoute
                component={AsyncAdminMonitoring}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_QUESTION_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminQuestion}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_SCHOOL_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminSchool}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_SETTINGS.path}
            element={
              <PrivateRoute
                component={AsyncAdminSettings}
                permissions="admin"
                showToast={this.props.showToast}
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_EXERCISE_BUILDER.path}
            element={
              <PrivateRoute
                component={AsyncAdminBuildExercise}
                permissions="admin"
                showToast={this.props.showToast}
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_EXERCISE_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminExercise}
                permissions="admin"
                showToast={this.props.showToast}
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_TAG_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminTag}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_WORKSHOP_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminWorkshop}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.LIBRARY_ROOT.path}
            element={
              <PrivateRoute
                component={AsyncLibraryRoot}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.LIBRARY_OBJECT.path}
            element={
              <PrivateRoute
                component={AsyncLibrary}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.COURSE_OBJECT.path}
            element={
              <PrivateRoute
                component={AsyncCoursePage}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_CONTENT_FOLDER.path}
            element={
              <PrivateRoute
                component={AsyncContentFolder}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          {/* TODO: Remove this route */}
          <Route
            path={TalaeraRoutes.ADMIN_CREATE_CONTENT_FILE.path}
            element={
              <PreserveQueryRedirect to={TalaeraRoutes.ADMIN_EDIT_CONTENT_FILE.path} />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_EDIT_CONTENT_FILE.path}
            element={
              <PrivateRoute
                component={AsyncEditContentFile}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_PRICING_MODEL_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminPricingModel}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_ROOT.path}
            element={
              <PrivateRoute
                component={AsyncAdminDashboard}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route path={TalaeraRoutes.CHANGE_PASSWORD.path} element={ChangeUserPassword} />

          <Route
            path={TalaeraRoutes.SIGN_OUT.path}
            element={
              <TalaeraDefaultBackground>
                <SignOut />
              </TalaeraDefaultBackground>
            }
          />

          <Route path={"*"} element={<UnauthRoutes showWrongLinkIfAuthenticated />} />
        </Routes>
      </ErrorBoundary>
    );
  }
}
